import React from "react";
import moment from "moment";
import { connect, useDispatch } from "react-redux";
import { selectors as softTokenSelectors } from "reducers/softToken";
import { selectors as afipPaymentLinkSelectors, actions as afipPaymentLinkActions } from "reducers/afipPaymentLink";
import { selectors as sessionSelectors } from "reducers/session";
import * as i18nUtils from "util/i18n";
import { addUtcOffset } from "util/date";
import CustomText from "pages/_components/CustomText/CustomText";
import Button from "pages/_components/Button";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedAmount from "pages/_components/FormattedAmount";
import { Grid, Row } from "react-bootstrap";
import { bool, shape, string } from "prop-types";

const VepDetail = ({ vep, isHistoric, fetchingDownload, type, isReviewPage }) => {
    const dispatch = useDispatch();

    const handleDownload = () => {
        const vepType = `${i18nUtils.get(`vep.type.${type}`)}`;
        dispatch(afipPaymentLinkActions.downloadVepDetail(vep, "pdf", isHistoric, vepType));
    };

    return (
        <div className="container full-width">
            <article className="container transaction-ticket accounts__details">
                <Grid>
                    <Row className="justify-content-center">
                        <h2 className="title-content">
                            <CustomText text="vep.detail.title" textType="I18N" />
                        </h2>
                        <GridTable>
                            <GridTable.Container className="box box-shadow accounts__details-box" columns={1} rows={10}>
                                <GridTable.Data columnStart={1} rowStart={1}>
                                    <CustomData
                                        dataClass="with-background"
                                        titleText="vep.payment.number"
                                        titleTextType="I18N"
                                        titleClass="text-Primary-primary-color"
                                        valueText={vep.id}
                                    />
                                </GridTable.Data>
                                {!isHistoric && (
                                    <GridTable.Data columnStart={1} rowStart={2}>
                                        <CustomData
                                            dataClass="with-background"
                                            titleText="vep.payment.dueDate"
                                            titleTextType="I18N"
                                            titleClass="text-Primary-primary-color"
                                            valueText={addUtcOffset(vep.expirationDate)}
                                            valueTextType="DATE"
                                        />
                                    </GridTable.Data>
                                )}
                                {isHistoric && !isReviewPage && vep.paymentDateTime && (
                                    <GridTable.Data columnStart={1} rowStart={2}>
                                        <CustomData
                                            dataClass="with-background"
                                            titleText="vep.payment.date"
                                            titleTextType="I18N"
                                            titleClass="text-Primary-primary-color"
                                            valueText={moment(vep.paymentDateTime.split(" ")[0], "YYMMDD")}
                                            valueTextType="DATE"
                                        />
                                    </GridTable.Data>
                                )}
                                <GridTable.Data columnStart={1} rowStart={3}>
                                    <CustomData
                                        dataClass="with-background"
                                        titleText="vep.payment.cuit.creator"
                                        titleTextType="I18N"
                                        titleClass="text-Primary-primary-color"
                                        valueText={vep.cuitOrigin}
                                    />
                                </GridTable.Data>
                                <GridTable.Data columnStart={1} rowStart={4}>
                                    <CustomData
                                        dataClass="with-background"
                                        titleText="vep.payment.cuit.taxpayer"
                                        titleTextType="I18N"
                                        titleClass="text-Primary-primary-color"
                                        valueText={vep.cuitTaxpayer}
                                    />
                                </GridTable.Data>
                                <GridTable.Data columnStart={1} rowStart={5}>
                                    <CustomData
                                        dataClass="with-background"
                                        titleText="vep.payment.cuit.authorizing"
                                        titleTextType="I18N"
                                        titleClass="text-Primary-primary-color"
                                        valueText={vep.cuitAutorizante}
                                    />
                                </GridTable.Data>
                                <GridTable.Data columnStart={1} rowStart={6}>
                                    <CustomData
                                        dataClass="with-background"
                                        titleText="vep.payment.amount.label"
                                        titleTextType="I18N"
                                        titleClass="text-Primary-primary-color"
                                        valueText={<FormattedAmount currency={vep.currency} quantity={vep.amount} />}
                                    />
                                </GridTable.Data>
                                <GridTable.Data columnStart={1} rowStart={7}>
                                    <CustomData
                                        dataClass="with-background"
                                        titleText="vep.payment.concept"
                                        titleTextType="I18N"
                                        titleClass="text-Primary-primary-color"
                                        valueText={vep.concept}
                                    />
                                </GridTable.Data>
                                <GridTable.Data columnStart={1} rowStart={8}>
                                    <CustomData
                                        dataClass="with-background"
                                        titleText="vep.payment.subconcept"
                                        titleTextType="I18N"
                                        titleClass="text-Primary-primary-color"
                                        valueText={vep.subconcept}
                                    />
                                </GridTable.Data>
                                <GridTable.Data columnStart={1} rowStart={9}>
                                    <CustomData
                                        dataClass="with-background"
                                        titleText="vep.payment.description"
                                        titleTextType="I18N"
                                        titleClass="text-Primary-primary-color"
                                        valueText={vep.description}
                                    />
                                </GridTable.Data>
                                <GridTable.Data columnStart={1} rowStart={10}>
                                    <CustomData
                                        dataClass="with-background"
                                        titleText="vep.payment.fiscalPeriod"
                                        titleTextType="I18N"
                                        titleClass="text-Primary-primary-color"
                                        valueText={vep.fiscalPeriod}
                                    />
                                </GridTable.Data>
                                <GridTable.Data columnStart={1} rowStart={11}>
                                    <CustomData
                                        dataClass="with-background"
                                        titleText="vep.payment.anticipatedFee"
                                        titleTextType="I18N"
                                        titleClass="text-Primary-primary-color"
                                        valueText={vep.anticipatedFee}
                                    />
                                </GridTable.Data>
                                {isHistoric && (
                                    <>
                                        {type !== null && (
                                            <GridTable.Data columnStart={1} rowStart={12}>
                                                <CustomData
                                                    dataClass="with-background"
                                                    titleText="vep.type.historic"
                                                    titleTextType="I18N"
                                                    titleClass="text-Primary-primary-color"
                                                    valueText={`${i18nUtils.get(`vep.type.${type}`)}`}
                                                />
                                            </GridTable.Data>
                                        )}
                                        <GridTable.Data columnStart={1} rowStart={type !== null ? 13 : 12}>
                                            <CustomData
                                                dataClass="with-background"
                                                titleText="vep.payment.bank"
                                                titleTextType="I18N"
                                                titleClass="text-Primary-primary-color"
                                                valueText={vep.paymentBank}
                                            />
                                        </GridTable.Data>
                                    </>
                                )}
                            </GridTable.Container>
                            <div>
                                <Button
                                    className="btn-primary no-print"
                                    image="images/figma/icon/download.svg"
                                    label="global.download"
                                    onClick={handleDownload}
                                    fetching={fetchingDownload}
                                    block
                                />
                            </div>
                        </GridTable>
                    </Row>
                </Grid>
            </article>
        </div>
    );
};

VepDetail.propTypes = {
    fetchingDownload: bool.isRequired,
    vep: shape({}).isRequired,
    isHistoric: bool,
    type: string,
    isReviewPage: bool,
};

VepDetail.defaultProps = {
    isHistoric: false,
    type: null,
    isReviewPage: false,
};

const mapStateToProps = (state) => ({
    fetchingDownload: afipPaymentLinkSelectors.getFetchingDownload(state),
    tokenInfo: softTokenSelectors.getTokenInfo(state),
    deviceStatus: softTokenSelectors.getDeviceStatus(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
});

export default connect(mapStateToProps)(VepDetail);
